import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  fill: "#39A95E",
  viewBox: "-96 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  id: "SVGRepo_bgCarrier",
  "stroke-width": "0"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("g", {
  id: "SVGRepo_tracerCarrier",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z" })
], -1)
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "col-year" }
const _hoisted_9 = { class: "w-35" }
const _hoisted_10 = { class: "w-35 col-authors" }
const _hoisted_11 = { "data-th": "Project: " }
const _hoisted_12 = { "data-th": "Publication: " }
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReadMore = _resolveComponent("ReadMore")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.items && _ctx.items.length > 0)
      ? (_openBlock(), _createElementBlock("thead", {
          key: 0,
          class: _normalizeClass('sort-' + this.sortOrder as string)
        }, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableColumns, (column) => {
              return (_openBlock(), _createElementBlock("th", {
                onClick: ($event: any) => (_ctx.onSortTable(column.key)),
                key: column.key,
                class: _normalizeClass('column-' + column.key as string),
                scope: "col"
              }, [
                _createElementVNode("span", null, [
                  _createElementVNode("span", null, _toDisplayString(column.name), 1),
                  (_ctx.sortColumn == column.key)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_6))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_1))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.items && _ctx.items.length > 0)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_8, _toDisplayString(item.Year), 1),
              _createElementVNode("td", _hoisted_9, _toDisplayString(item.Title), 1),
              _createElementVNode("td", _hoisted_10, [
                (_openBlock(), _createBlock(_component_ReadMore, {
                  key: item.ID.toString() + '-' + _ctx.isMobile.toString(),
                  longText: item.Authors,
                  isMobile: _ctx.isMobile
                }, null, 8, ["longText", "isMobile"]))
              ]),
              _createElementVNode("td", _hoisted_11, _toDisplayString(item.Project), 1),
              _createElementVNode("td", _hoisted_12, _toDisplayString(item.Journal), 1),
              _createElementVNode("td", {
                "data-th": "Media: ",
                class: "col-media",
                innerHTML: item.Media
              }, null, 8, _hoisted_13)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}